import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

export const authGuard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const aux = localStorage.getItem("auth");
  let auth;
  if (aux) {
    auth = JSON.parse(aux);
  }
  const isAuthenticated = auth?.profile?.id ?? auth?.profile?._id;

  if (!to.matched.length) {
    console.log('LOCALSTORAGE', aux)
    if (isAuthenticated) {
      next({ name: "dashboard" });
    } else {
      next({ name: "login" });
    }
  } else if (to.meta?.requiredAuth !== undefined) {
    if (
      (isAuthenticated && to.meta.requiredAuth) ||
      (!isAuthenticated && !to.meta.requiredAuth)
    ) {
      next();
    } else if (!isAuthenticated && to.meta.requiredAuth) {
      next({ name: "login" });
    } else {
      next({ name: "dashboard" });
    }
  } else {
    // console.log(isAuthenticated);
    next();
  }
};
